import { render, staticRenderFns } from "./wx-login.vue?vue&type=template&id=0413d1f8&"
import script from "./wx-login.vue?vue&type=script&lang=js&"
export * from "./wx-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports